import { Pipe, PipeTransform } from '@angular/core';
import { FilterSelectionSubTab } from '@shared/models/entity-subtabs.const';
import { DataObject } from '@shared/models/data-object.model';

export const DEFAULT_ALL_ID = 'All';

@Pipe({
  name: 'customFuncFilter',
  standalone: false,
})
export class CustomFuncFilterPipe implements PipeTransform {
  transform(
    records: DataObject[],
    filterType: string,
    customFunc: Function,
    path: string,
    filterSeclection: FilterSelectionSubTab
  ) {
    if (customFunc != null && filterType !== DEFAULT_ALL_ID) {
      return customFunc(records, filterType, path, filterSeclection);
    }
    return records || [];
  }
}
